import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "iframe-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}

import CloseIcon from './CloseIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportOverlay',
  props: {
    visible: { type: Boolean },
    userName: {},
    iframeSrc: {}
  },
  emits: ["close"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["support-overlay", { 'is-open': _ctx.visible }])
  }, [
    _createElementVNode("button", {
      class: "close-button",
      "aria-label": "close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    }, [
      _createVNode(CloseIcon, { size: 10 })
    ]),
    (_ctx.userName && _ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock("iframe", {
            key: _ctx.iframeSrc,
            class: "support-iframe",
            src: _ctx.iframeSrc
          }, null, 8, _hoisted_2))
        ]))
      : (!_ctx.userName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "用户信息初始化失败，请联系管理员"))
        : _createCommentVNode("", true)
  ], 2))
}
}

})